import localeHu from '@angular/common/locales/hu';
import localeHuExtra from '@angular/common/locales/extra/hu';

import { LanguageEnum, Language } from '../core/interfaces/language-types';

export default class HungarianLanguage extends Language {
  protected locale = localeHu;
  protected localeExtra = localeHuExtra;
  protected details = {
    image: 'images/flags/hu.png',
    title: 'Hungarian',
    enum: LanguageEnum.Hungarian,
    aira: 'Hungarian Selected',
    select: 'Choose Hungarian Language',
    abre: 'hu'
  };
}
